// src/pages/WinnerDetails.js
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaGift } from "react-icons/fa";

// Updated dummy data with gift images
const dummyWinners = {
  w1: {
    name: "Zara",
    month: "May 2025",
    reward: "Amazon Voucher ₹500",
    description: "Top performer of May for completing 120 tasks!",
    profileImage: "",
    giftImage: "https://cdn-icons-png.flaticon.com/512/1170/1170576.png", // Example gift image
    giftProof: "https://cdn-icons-png.flaticon.com/512/1170/1170576.png"
  },
  w2: {
    name: "Mihir",
    month: "April 2025",
    reward: "Bluetooth Earbuds",
    description: "Best community contributor with 80+ reviews.",
    profileImage: "",
    giftImage: "https://cdn-icons-png.flaticon.com/512/1029/1029183.png",
  },
  w3: {
    name: "Sanya",
    month: "March 2025",
    reward: "Flipkart Voucher ₹300",
    description: "Completed 90 product uploads and won this reward.",
    profileImage: "",
    giftImage: "https://cdn-icons-png.flaticon.com/512/3144/3144456.png",
  },
};

const WinnerDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const winner = dummyWinners[id];

  if (!winner) {
    return (
      <div className="max-w-xl mx-auto mt-10 text-center text-red-600 font-semibold">
        ❌ Winner not found.
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto mt-6 px-4">
      <div className="bg-white shadow-lg rounded-lg p-6">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 flex items-center gap-2 text-sm text-gray-500 hover:text-orange-500"
        >
          <FaArrowLeft /> Back
        </button>

        <div className="flex flex-col items-center text-center">
          {/* User Avatar */}
          <div className="w-24 h-24 rounded-full overflow-hidden bg-gray-200 mb-4">
            <img
              src={
                winner.profileImage ||
                `https://ui-avatars.com/api/?name=${winner.name}&background=random`
              }
              alt={winner.name}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Name & Info */}
          <h2 className="text-2xl font-bold text-orange-600 mb-1">{winner.name}</h2>
          <p className="text-sm text-gray-500 mb-2">🏆 Winner - {winner.month}</p>

          {/* Gift Info */}
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded mb-4 flex items-center justify-center gap-3 flex-wrap">
            <FaGift className="text-green-600 text-lg" />
            <strong>{winner.reward}</strong>
          </div>

          {/* Gift Image */}
          {winner.giftImage && (
            <div className="my-4">
              <img
                src={winner.giftImage}
                alt="Gift"
                className="w-32 h-32 object-contain mx-auto rounded-md border border-gray-200 shadow"
              />
              <p className="text-xs text-gray-500 mt-1">Actual gift awarded</p>
            </div>
          )}


          {/* Proof of Reward Section */}
          {winner.giftProof && (
            <div className="mt-6 bg-gray-50 p-4 rounded-lg border border-gray-200">
              <h3 className="text-md font-semibold text-gray-800 mb-2">📸 Gift Proof</h3>
              <img
                src={winner.giftProof}
                alt="Gift Proof"
                className="rounded-md border shadow w-full max-w-md mx-auto"
              />
              <p className="text-xs text-gray-500 text-center mt-2">Verified screenshot of reward sent to the winner</p>
            </div>
          )}

          {/* Description */}
          <p className="text-gray-700 text-sm mt-2">{winner.description}</p>


        </div>
      </div>
    </div>
  );
};


export
  default WinnerDetails;
